// extracted by mini-css-extract-plugin
export default {"root":"RLZTOSIscA6b_oOXO4vt"};